import auctionsApi from '../../api/apiCars'
import apiCars from './../../api/apiCars'

const state = {
    deleteModal: false,
    transferModal: false,
    transferUserId: '',
    activeBidId: '',
    car: ''
}
const getters = {
    getSingleCar: (state) => {
        return state.car
    },
    getSingleCarDeleteModalStatus: (state) => {
        return state.deleteModal
    },
    getSingleCarTransferModalStatus: (state) => {
        return state.transferModal
    },
    getFavoriteCarTransferModalStatus: (state) => (lotId) => {
        return state.transferModal && state.activeBidId === lotId
    },
    getSingleCarTransferUserId: (state) => {
        return state.transferUserId
    }
}

const mutations = {
    setSingleCar: (state, carData) => {
        state.car = carData
    },
    updateSingleCarDeleteModalStatus: (state, newStatus) => {
        state.deleteModal = newStatus
    },
    updateSingleCarTransferModalStatus: (state, newStatus) => {
        state.transferModal = newStatus
    },
    updateFavoriteCarTransferModalStatus: (state, newStatus) => {
        state.transferModal = newStatus.status
        state.activeBidId = newStatus.bidId
    },
    updateSingleCarTransferUserId: (state, newValue) => {
        state.transferUserId = newValue
    }
}

const actions = {
    fetchSingleCarData: ({ commit, dispatch }, carId) => {
        dispatch('setStatusLoading')
        auctionsApi.getSingleCarRequest(carId)
            .then((response) => {
                commit('setSingleCar', response.data)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setSingleCarData: ({ commit }, newData) => {
        commit('setSingleCar', newData)
    },
    setSingleCarDeleteModalStatus: ({ commit }, newStatus) => {
        commit('updateSingleCarDeleteModalStatus', newStatus)
    },
    setSingleCarTransferModalStatus: ({ commit }, newStatus) => {
        commit('updateSingleCarTransferModalStatus', newStatus)
    },
    setFavoriteCarTransferModalStatus: ({ commit }, newStatus) => {
        commit('updateFavoriteCarTransferModalStatus', newStatus)
    },
    deleteSingleCarById: ({ commit }, carId) => {
        apiCars
            .deleteCarRequest(carId)
            .then((response) => {
                commit('updateSingleCarDeleteModalStatus', false)
            })
            .catch(error => console.log(error))
    },
    setSingleCarTransferUserId: ({ commit }, newStatus) => {
        commit('updateSingleCarTransferUserId', newStatus)
    },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/singleCar.js